var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMessages = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.833 9.166c0-.46.374-.833.834-.833.46 0 .833.373.833.833 0 .46-.373.833-.833.833-.46 0-.834-.373-.834-.833zM10 8.333c-.46 0-.833.373-.833.833 0 .46.373.833.833.833.46 0 .833-.373.833-.833 0-.46-.373-.833-.833-.833zm3.333 0c-.46 0-.833.373-.833.833 0 .46.373.833.833.833.46 0 .834-.373.834-.833 0-.46-.374-.833-.834-.833zm3.249 1.912c-.422 2.712-2.608 4.961-5.316 5.469-1.307.246-2.639.105-3.847-.406-.343-.145-.697-.219-1.044-.219-.159 0-.316.015-.47.046l-2.343.469.47-2.348c.098-.488.037-1.01-.173-1.508-.512-1.209-.652-2.54-.406-3.848.507-2.707 2.756-4.893 5.468-5.316 2.159-.336 4.27.344 5.793 1.868 1.524 1.524 2.205 3.636 1.868 5.793m-.69-6.972C13.99 1.37 11.356.521 8.666.937c-3.398.53-6.215 3.266-6.85 6.656-.307 1.631-.13 3.293.509 4.804.08.192.106.371.074.532l-.715 3.574c-.055.273.03.555.228.752.158.159.37.244.59.244.054 0 .108-.005.163-.015l3.569-.715c.205-.039.403.019.536.074 1.512.639 3.174.815 4.804.509 3.39-.636 6.127-3.453 6.657-6.85.418-2.69-.433-5.324-2.337-7.229",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessages, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/messages.c53c23ba.svg";
export { ForwardRef as ReactComponent };